import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let Toast = class Toast extends Vue {
    removeMessage(index) {
        this.$data.toastArray.splice(index, 1);
    }
    removeError(index) {
        this.$data.toastErrorArray.splice(index, 1);
    }
    showToastMsg(obj) {
        const guid = this.guidGenerator();
        if (obj.type === 'error') {
            this.$data.toastErrorArray.push({ message: obj.message, id: guid });
            setTimeout(() => { this.removeErrorToast(guid); }, 6000);
        }
        else {
            this.$data.toastArray.push({ message: obj.message, id: guid });
            setTimeout(() => { this.removeToast(guid); }, 12000);
        }
    }
    guidGenerator() {
        const S4 = () => {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
    }
    removeToast(idstring) {
        for (let i = 0; i < this.$data.toastArray.length; i++) {
            if (this.$data.toastArray[i].id === idstring) {
                this.$data.toastArray.splice(i, 1);
            }
        }
    }
    removeErrorToast(idstring) {
        for (let i = 0; i < this.$data.toastErrorArray.length; i++) {
            if (this.$data.toastErrorArray[i].id === idstring) {
                this.$data.toastErrorArray.splice(i, 1);
            }
        }
    }
};
Toast = __decorate([
    Component({
        data() {
            return {
                showToast: false,
                toastMsg: '',
                showToastError: false,
                toastErrorMsg: '',
                toastArray: [],
                toastErrorArray: [],
            };
        },
        created() {
            // set a event to detect when a toast has triggered
            window.eventBus.$on('newToast', (obj) => {
                this.showToastMsg(obj);
            });
        },
        beforeDestroy() {
            window.eventBus.$off('newToast');
        },
    })
], Toast);
export default Toast;
